var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 100,
    viewBox: "0 0 212 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1839_3241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.289 20.8242V67.6008C96.289 73.5885 91.5537 78.6894 85.5661 78.7214C82.5723 78.7351 79.8527 77.5238 77.8873 75.5676C75.9447 73.6159 74.7335 70.9192 74.7335 67.9436V26.8758C74.7335 23.9322 72.3476 21.5509 69.4086 21.5509H11.5206C5.53293 21.5509 0.432013 16.8156 0.400018 10.828C0.386305 7.8342 1.59754 5.11463 3.55381 3.14922C5.5055 1.21124 8.20222 0 11.1778 0H75.4694C86.9693 0 96.2936 9.32425 96.2936 20.8242H96.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.63 15.1481C208.651 8.46574 203.376 3.19571 196.68 1.23031C194.834 0.686392 192.886 0.398438 190.862 0.398438H137.16C135.135 0.398438 133.188 0.686392 131.342 1.23031C124.641 3.20028 119.367 8.46574 117.392 15.1573C116.843 17.013 116.546 18.9784 116.546 21.0124V57.7197C116.546 59.7537 116.843 61.7191 117.392 63.5748C119.367 70.2618 124.641 75.5318 131.342 77.5018C133.188 78.0457 135.135 78.3337 137.16 78.3337H190.862C192.886 78.3337 194.834 78.0457 196.68 77.5018C203.376 75.5318 208.651 70.2663 210.63 63.584C211.178 61.7283 211.476 59.7583 211.476 57.7243V21.0078C211.476 18.9738 211.178 17.0038 210.63 15.1481ZM184.865 56.993H143.148C140.236 56.993 137.878 54.6299 137.878 51.7184V27.0091C137.878 24.0976 140.236 21.7345 143.148 21.7345H184.865C187.776 21.7345 190.139 24.0976 190.139 27.0091V51.7184C190.139 54.6299 187.776 56.993 184.865 56.993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.668 132.177V101.604C174.668 95.6159 169.932 90.515 163.945 90.483C160.951 90.4693 158.231 91.6805 156.266 93.6368C154.323 95.5885 153.112 98.2852 153.112 101.261V126.125C153.112 129.069 150.726 131.45 147.787 131.45H86.7774C80.7898 131.45 75.6888 136.186 75.6569 142.173C75.6431 145.167 76.8544 147.887 78.8106 149.852C80.7623 151.795 83.4591 153.006 86.4346 153.006H153.843C165.343 153.006 174.668 143.682 174.668 132.182V132.177Z",
    fill: "url(#paint0_linear_1839_3241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.955 141.555C211.955 147.877 206.832 153 200.51 153H200.067C196.909 153 194.043 151.716 191.972 149.65C189.893 147.566 188.604 144.677 188.622 141.496C188.649 135.143 194.07 130.11 200.433 130.11H200.51C206.832 130.11 211.955 135.234 211.955 141.555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8366 37.7319V58.6612H10.8625C5.08513 58.6612 0.400146 53.9762 0.400146 48.1989C0.400146 45.3056 1.57025 42.6912 3.46709 40.7989C5.36394 38.902 7.97839 37.7319 10.8671 37.7319H95.8366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.289 110.68V141.875C96.289 147.863 91.5537 152.963 85.5661 152.995C82.5723 153.009 79.8527 151.798 77.8873 149.842C75.9447 147.89 74.7335 145.193 74.7335 142.218V116.731C74.7335 113.788 72.3476 111.407 69.4086 111.407H11.5206C5.53293 111.407 0.432013 106.671 0.400018 100.684C0.386305 97.6898 1.59754 94.9703 3.55381 93.0049C5.5055 91.0623 8.20222 89.8511 11.1778 89.8511H75.4694C86.9693 89.8511 96.2936 99.1753 96.2936 110.675L96.289 110.68Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1839_3241",
    x1: 86.8002,
    y1: 121.742,
    x2: 174.668,
    y2: 121.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.192317,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1839_3241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 211.555,
    height: 153,
    fill: "white",
    transform: "translate(0.400146)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigLogo);
export default __webpack_public_path__ + "static/media/BigLogo.2b277ee4f02c26d89c6fe6363089ee3e.svg";
export { ForwardRef as ReactComponent };